<template>
  <div class="pack">
    <transition name="fade">
      <div class="item-added-overlay" v-if="addedItemId() == pack.id">
        <span class="added-text">Added</span>
      </div>
    </transition>

    <div class="pack-card" :style="packStyle">
      <!-- Pack Title -->
      <div class="pack-header">
        <h3 class="pack-title">{{ pack.title }}</h3>
      </div>

      <div class="pack-bottom">
        <p class="pack-description" v-if="pack.description">
          {{ pack.description }}
        </p>

        <div class="price-buy">
          <div class="price">
            <span class="price-value">{{ formattedPriceValue }}</span>
            <span class="currency-symbol">{{ formattedCurrency }}</span>
          </div>
          <button class="buy-btn" @click="addToCart">BUY</button>
        </div>

        <div class="pack-contents" :class="{ open: isContentVisible }">
          <div class="contents-header" @click="toggleContent">
            <span>Pack Contents</span>
            <svg
              class="arrow-icon"
              :class="{ rotated: isContentVisible }"
              width="12"
              height="7"
              viewBox="0 0 12 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L6 6L11 1"
                stroke="#F75D10"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="contents-items">
            <div class="items-grid">
              <div class="item-image" v-for="item in pack.items" :key="item.id">
                <img :src="imgDomain + item.image_url" :alt="item.title" />
                <span class="quantity" v-if="item.quantity > 1"
                  >{{ item.quantity }}x</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackCard",
  props: {
    pack: {
      type: Object,
      required: true,
    },
  },
  inject: ["addedItemId", "getCurrency"],
  data() {
    return {
      isContentVisible: false,
      imgDomain: "",
    };
  },
  computed: {
    packStyle() {
      if (this.pack && this.pack.image_url) {
        return {
          "background-image": `url(${this.pack.image_url})`,
          "background-repeat": "no-repeat",
          "background-position": "top center",
          "background-size": "100% 130px",
        };
      }
      return {};
    },
    formattedPriceValue() {
      const price = this.pack.price;
      return price % 1 === 0
        ? Number(price).toFixed(0)
        : Number(price).toFixed(2);
    },
    formattedCurrency() {
      return this.getCurrency() || "€";
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    toggleContent() {
      this.isContentVisible = !this.isContentVisible;
    },
    addToCart() {
      this.$emit("addToCart", this.pack, this.pack.id, 1, "pack");
    },
  },
};
</script>

<style scoped>
.pack {
  background: #2a2830e0;
  font-family: "Outfit", sans-serif;
  position: relative;
  width: 100%;
  border-radius: 4px;
}

.pack-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pack-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 130px;
  position: relative;
}

.pack-title {
  font-family: "Outfit", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  max-width: 240px;
  padding: 0 12px;
}

.pack-description {
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  min-height: 95px;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #a7a7b1;
  margin-bottom: 6px;
}

.pack-bottom {
  padding: 18px 24px 32px;
}

.price-buy {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.price {
  font-family: "Outfit", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 4px;
}

.price-value {
  font-weight: 700;
}

.currency-symbol {
  color: #f75d10;
  font-weight: 700;
}

.buy-btn {
  width: 81px;
  height: 38px;
  position: relative;
  background: linear-gradient(180deg, #f75d10 0%, #da1e01 100%);
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-family: "Outfit", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  overflow: hidden;
}

.buy-btn::before {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  background: radial-gradient(
    50% 50% at 50% 0%,
    rgba(255, 255, 255, 0.3) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  border-radius: 2px;
}

.pack-contents {
  width: 100%;
}

.contents-header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #f75d10;
  position: relative;
  cursor: pointer;
}

.arrow-icon {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.arrow-icon.rotated {
  transform: rotate(180deg);
}

.pack-contents.open .arrow-icon {
  transform: rotate(180deg);
}

.contents-items {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease, padding 0.3s, margin-top 0.3s ease;
}

.pack-contents.open .contents-items {
  max-height: 500px;
  margin-top: 32px;
}

.items-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.item-image {
  width: 62px;
  height: 62px;
  background: #100f14;
  border-radius: 4px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-image img {
  max-width: 38px;
  max-height: 38px;
  object-fit: contain;
}

.item-image .quantity {
  position: absolute;
  bottom: 8px;
  right: 2px;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

@media (max-width: 767px) {
  .pack-title {
    font-size: 18px;
    line-height: 22px;
  }

  .pack-description {
    font-size: 13px;
    line-height: 18px;
  }
}
</style>
